import useChat from "@/views/Home/useData/useChat/useChat";
import controlScroll from "./controlScroll";
import { throttle } from "lodash";
import { watch, reactive } from "vue";

// import { changeInputBoxType, inputBoxStatus } from "../input-v2/useInputV2";
const {
  chatList,
  chatStatus,
  initChat,
  saveChat,
  nextChatPage,
  setType,
  stopAbort,
  sendMsg,
  deleteChat,
  deleteChatObj,
  clearChat,
  gptParams,
  bindDialogue,
  clearContext,
  bindExportEvents,
} = useChat();

function chatScroll(chat = {}, querySelector) {
  const { chatList, chatStatus, dialogueStatus, nextChatPage } = chat;
  const {
    scrollStatus,
    initParams: initScrollParams,
    scrollToBottom,
    mixins: scrollMixins,
    scrollToTop,
  } = controlScroll(querySelector, {
    touchTop: throttle(
      async () => {
        const dom = scrollStatus.scrollDom;
        let prevScrollHeight = dom.scrollHeight;
        await nextChatPage();

        const curScrollHeight = dom.scrollHeight;
        // 滚动到之前的位置
        dom.scrollTo({
          left: 0,
          top: curScrollHeight - prevScrollHeight,
        });
      },
      800,
      {
        leading: true,
        trailing: false,
      }
    ),
  });

  const mixins = {
    mixins: [scrollMixins],
  };
  const autoScrollToBottom = throttle((type) => {
    if (!scrollStatus.isUserControlling) {
      scrollToBottom(type);
    }
  }, 500);
  watch(
    () => chatStatus.isReplying,
    (newVal) => {
      autoScrollToBottom();
    }
  );
  const watchChatList = reactive({ chatList });
  let cacheContent = "";
  watch(
    () => dialogueStatus.sessionId,
    (newVal) => {
      scrollStatus.isUserControlling = false;
      autoScrollToBottom();
    },
    {
      immediate: true,
      deep: true,
    }
  );
  watch(
    () => watchChatList.chatList[watchChatList.chatList.length - 1],
    (newVal) => {
      if (newVal && newVal.role === "assistant") {
        if (cacheContent !== newVal.content) {
          autoScrollToBottom();
        }
      }
    },
    {
      immediate: true,
      deep: true,
    }
  );
  return {
    mixins,
    initScrollParams,
    scrollStatus,
    scrollToBottom,
    scrollToTop,
  };
}

watch(
  () => chatStatus.model,
  () => {
    // 切换模型的时候，重置输入框
    // changeInputBoxType("input");
  }
);

export {
  chatList,
  chatStatus,
  initChat,
  saveChat,
  nextChatPage,
  setType,
  stopAbort,
  sendMsg,
  deleteChat,
  deleteChatObj,
  clearChat,
  gptParams,
  bindDialogue,
  clearContext,
  bindExportEvents,
  chatScroll,
};
